import { useState, useEffect, useCallback } from 'react';

/**
 * Custom hook that listens to authentication events (such as user login)
 * and forces a complete component tree re-render in wealthIQ.
 */
export const useForceRerenderOnLogin = () => {
  const [renderKey, setRenderKey] = useState(0);

  const forceRerender = useCallback(() => {
    setRenderKey((prevKey) => prevKey + 1);
  }, []);

  useEffect(() => {
    const handleAuthChange = () => {
      setRenderKey((prevKey) => prevKey + 1);
    };

    window.addEventListener('auth:changed', handleAuthChange);
    window.addEventListener('auth:login', handleAuthChange);

    return () => {
      window.removeEventListener('auth:changed', handleAuthChange);
      window.removeEventListener('auth:login', handleAuthChange);
    };
  }, []);

  return { renderKey, forceRerender };
};
